import React, { useState } from 'react'
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Grid,
  Snackbar,
  Alert,
  Link,
} from '@mui/material'
import deadSea from '../assets/Nuweiba.jpg'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import CallOutlinedIcon from '@mui/icons-material/CallOutlined'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import { useTranslation } from 'react-i18next'
import { WhatsApp } from '@mui/icons-material'

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' })
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  })
  const { t } = useTranslation()

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const onSubmit = async (event) => {
    event.preventDefault()
    const formData = new FormData(event.target)

    formData.append('access_key', '4af3e49b-67ea-4812-a199-a0fce2d5c0d5')
    //be9e72db-d102-46f3-82a5-17ca07e09a83

    const object = Object.fromEntries(formData)
    const json = JSON.stringify(object)

    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: json,
      }).then((res) => res.json())

      if (res.success) {
        setSnackbar({
          open: true,
          message: 'Message sent successfully!',
          severity: 'success',
        })
        setFormData({ name: '', email: '', phone: '', message: '' }) // Reset form
      } else {
        setSnackbar({
          open: true,
          message: 'Failed to send message.',
          severity: 'error',
        })
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'An error occurred. Please try again.',
        severity: 'error',
      })
    }
  }

  return (
    <Container
      maxWidth="sm"
      sx={{
        height: '100%',
        p: 3,
        boxShadow: 3,
        borderRadius: 2,
        width: '100%',
        minWidth: '100%',
        backgroundColor: '#ffffff',
      }}
    >
      <Box
        sx={{
          flexDirection: 'column',
          position: 'relative',
          height: '100%',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          backgroundColor: 'transparent',
        }}
      >
        {/* Fixed Background */}
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${deadSea})`, // ✅ Fix background image
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            zIndex: -1, // ✅ Sends it behind the text
          }}
        />
        <Grid
          container
          spacing={{ xs: 2, md: 4 }}
          sx={{
            width: '100%',
            minWidth: '100%',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              fontWeight={700}
              align="center"
              gutterBottom
            >
              {t('Titles.contact_us')}
            </Typography>
            <Box
              component="form"
              onSubmit={onSubmit}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                backgroundColor: 'text.secondary',
                borderRadius: 2,
                padding: '20px',
              }}
            >
              <TextField
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                fullWidth
                required
                sx={{
                  backgroundColor: 'text.secondary', // Change this to your desired input color
                  borderRadius: 2,
                  boxShadow: 1,
                  '& .MuiInputLabel-root': {
                    color: 'secondary.main', // Change this to your desired label color
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'text.secondary', // Optional: Change border color if needed
                    },
                    '&:hover fieldset': {
                      borderColor: 'text.secondary', // Optional: Change border color on hover
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'secondary.main', // Optional: Change border color when focused
                    },
                  },
                }}
              />
              <TextField
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                fullWidth
                required
                sx={{
                  backgroundColor: 'text.secondary', // Change this to your desired input color
                  borderRadius: 2,
                  boxShadow: 1,
                  '& .MuiInputLabel-root': {
                    color: 'secondary.main', // Change this to your desired label color
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'text.secondary', // Optional: Change border color if needed
                    },
                    '&:hover fieldset': {
                      borderColor: 'text.secondary', // Optional: Change border color on hover
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'secondary.main', // Optional: Change border color when focused
                    },
                  },
                }}
              />
              <TextField
                label="Phone Number"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                fullWidth
                required
                sx={{
                  backgroundColor: 'text.secondary', // Change this to your desired input color
                  borderRadius: 2,
                  boxShadow: 1,
                  '& .MuiInputLabel-root': {
                    color: 'secondary.main', // Change this to your desired label color
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'text.secondary', // Optional: Change border color if needed
                    },
                    '&:hover fieldset': {
                      borderColor: 'text.secondary', // Optional: Change border color on hover
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'secondary.main', // Optional: Change border color when focused
                    },
                  },
                }}
              />
              <TextField
                label="Message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                multiline
                rows={4}
                fullWidth
                required
                sx={{
                  resize: 'both',
                  backgroundColor: 'text.secondary', // Change this to your desired input color
                  borderRadius: 2,
                  boxShadow: 1,
                  '& .MuiInputLabel-root': {
                    color: 'secondary.main', // Change this to your desired label color
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'text.secondary', // Optional: Change border color if needed
                    },
                    '&:hover fieldset': {
                      borderColor: 'text.secondary', // Optional: Change border color on hover
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'secondary.main', // Optional: Change border color when focused
                    },
                  },
                }}
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
              >
                Send Message
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              fontWeight={700}
              align="center"
              gutterBottom
            >
              {t('Titles.contact_info')}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                backgroundColor: 'text.secondary',
                borderRadius: 2,
                padding: '20px',
              }}
            >
              <EmailOutlinedIcon />
              <Typography variant="body2">
                <strong> Email: </strong>
                <Link
                  href="mailto:Sales4@nairoukhtravel.com"
                  color="inherit"
                  style={{ textDecoration: 'none', fontWeight: 600 }}
                >
                  Sales4@nairoukhtravel.com
                </Link>{' '}
                <strong> | Email: </strong>
                <Link
                  href="mailto:Aqaba@nairoukhtravel.com"
                  color="inherit"
                  style={{ textDecoration: 'none', fontWeight: 600 }}
                >
                  Aqaba@nairoukhtravel.com
                </Link>
              </Typography>
              <Typography variant="body2">
                <LocationOnOutlinedIcon />
              </Typography>
              <Typography variant="body1">
                <strong>Address:</strong> Aqaba, Jordan,behind nairoukh hotel
              </Typography>
              <Typography variant="body2">
                <CallOutlinedIcon />
                <WhatsApp />
              </Typography>
              <Typography variant="body1">
                {' '}
                <Link
                  href="tel:+962799151843"
                  style={{ textDecoration: 'none' }}
                  color="inherit"
                >
                  <strong>+962799151843{' | '}</strong>
                </Link>
                <Link
                  href="tel:+962799309108"
                  style={{ textDecoration: 'none' }}
                  color="inherit"
                >
                  <strong>+962799309108{' | '} </strong>
                </Link>
                <Link
                  href="tel:+962797702111"
                  style={{ textDecoration: 'none' }}
                  color="inherit"
                >
                  <strong> +962797702111{''}</strong>
                </Link>
              </Typography>
              <Typography variant="body2">
                <LocationOnOutlinedIcon />
              </Typography>
              <Typography variant="body1">
                <strong>Address:</strong> Amman, Jordan, Alwehdat MiddleEast
                Circle
              </Typography>
              <Typography variant="body2">
                <CallOutlinedIcon />
                <WhatsApp />
              </Typography>
              <Typography variant="body1">
                {' '}
                <Link
                  href="tel:+962796000941"
                  style={{ textDecoration: 'none' }}
                  color="inherit"
                >
                  <strong>+962796000941{' | '}</strong>
                </Link>
                <Link
                  href="tel:+962777140142"
                  style={{ textDecoration: 'none' }}
                  color="inherit"
                >
                  <strong>+962777140142{''} </strong>
                </Link>
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          <Alert
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}
            sx={{ width: '100%' }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </Container>
  )
}

export default Contact
